import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navbar } from '../navbar/navbar';
import { Profile } from 'api/api-profile';
import { FormBuilder } from '../forms/form';
import { Helpers } from '../helpers/helpers';
import Cookie from 'react-cookie';

import { TosCTAdisclaimer } from '../terms/cta-disclaimer';
import CheckboxField from "../reduxForms/fields/CheckboxField/CheckboxField";
import { FormattedMessage } from 'react-intl';

export class SocialEmail extends Component {
  constructor (props) {
    super(props);
    this.state = {
      modalShow: true,
      errorMsg: null
    };

    this.signinCallback = this.signinCallback.bind(this);
    this.signupCallback = this.signupCallback.bind(this);
    this.createNewSocialUser = this.createNewSocialUser.bind(this);
    this.signupAction = this.signupAction.bind(this);
    this.renderEmailForm = this.renderEmailForm.bind(this);
  }

  componentWillUnmount () {
    const { socialProvider } = this.props;

    // If user closes modal during FB sign up flow,
    // we want to un-auth them from FB.
    if ('facebook' === socialProvider) {
      FB.logout(() => { return; });
    }
  }

  signinCallback (response) {
    if (response.error) {
      let errorMsg = response.error_description;
      if (400 < response.statusCode || 'Invalid JSON' === errorMsg) {
        errorMsg = <FormattedMessage id="shared_components.social_email_form.invalid_error" defaultMessage="An unexpected error occurred. Please try again in a few minutes."/>;
      }
      this.setState({ errorMsg });
    } else {
      if (window) {
        Helpers.setCookies(response);
      }
      analyticsIntegrations.accountLogin(response.SSOid);

      // Render Navbar
      Navbar.refreshUserInfo();
      $('#modal-container').modal('hide');
    }
  }


  signupCallback (username, response) {
    const {
      socialProvider,
      extraSignupAttrs: {
        source
      } = {}
    } = this.props;

    if (response.error) {
      let errorMsg = response.error_description;

      if (400 < response.statusCode || 'Invalid JSON' === errorMsg) {
        errorMsg = <FormattedMessage id="shared_components.social_email_form.invalid_error" defaultMessage="An unexpected error occurred. Please try again in a few minutes."/>;
      }

      if ('jwt expired' === errorMsg) {
        errorMsg = <FormattedMessage id="shared_components.social_email_form.expired_error" defaultMessage="Your sign up session has expired. Click the X to start over."/>;
      }

      if ('Username or provider_id  already in use' === errorMsg) {
        errorMsg = <div><FormattedMessage id="shared_components.social_email_form.already_taken_error" defaultMessage="This email is already taken. Please {link} instead." values={{ link: (<a href="/signin"><FormattedMessage id="shared_components.social_email_form.login" defaultMessage="log in"/></a>)}}/></div>;
      }

      this.setState({ errorMsg });
    } else {
      if (window) {
        Helpers.setCookies(response);
      }

      /* Render navbar & fire signup segment call using extraSignupAttrs */
      if (!this.props.isSignupPage) {
        const extraSignupAttrs = {
          method: socialProvider,
          source
        };
        Navbar.refreshUserInfo(true, true, extraSignupAttrs);
      }
      /* Render 'About You' Modal
         fn name is moveToProfileModal from
         SignupManager */
      this.props.callbackFn();
    }
  }

  createNewSocialUser (username, callback) {
    /* TODO: would be good to add a grants check here
       rather than wait for an error */
    const { socialProvider, socialData, socialAccessToken } = this.props;
    /* pre sign-up, regardless of other entitlements,
       we will attribute the tastemaker here
       if a user has been on their page */
    const promoId = this.props.entitlementId || PSSessions.Cookies('tm_ent') || PSSessions.Cookies('promo-id');
    const attrUrl = PSSessions.Cookies('PSAttrUrl');
    const attrRef = PSSessions.Cookies('PSAttrReferrer');
    const forterToken = window.fcToken || PSSessions.Cookies('forterToken');
    const emailOptOut = document.getElementById('email_opt_out').checked;
    const locale = Cookie.load('preferred_locale') || Cookie.load('initial_locale');

    const { email } = socialData || {};

    if (email !== username) {
      /* email input is different from the social provider's response */
      analyticsIntegrations.socialEmailChanged(socialProvider, socialProvider);
    }

    // unsubscribe in vero will not work in alpha/beta due to a
    // segment alias call to vero that is only filtered out for prod
    const profileBody = {
      username,
      provider: socialProvider,
      social_access_token: socialAccessToken,
      ga_client_id: analyticsIntegrations.getGoogleAnalyticsID(),
      attr_url: attrUrl,
      attr_referrer: attrRef,
      social_data: socialData,
      unsubscribe: emailOptOut,
      ...(locale && { preferred_locale: locale }),
      forterTokenCookie: forterToken
    };

    Cookie.save('preferred_locale', locale, {
      path: '/',
      expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
      domain: window.location.host,
      secure: -1 !== window.location.protocol.indexOf('s'),
    });

    if ('facebook' === socialProvider) {
      profileBody.provider_id = socialData.id;
    } else if ('google' === socialProvider) {
      profileBody.provider_id = socialData.sub;
    }

    if (promoId) {
      profileBody.entitlement_id = promoId;
    }

    /* Callback `signupCallback` is passed from `signupAction` */
    Profile.createSocial(profileBody, callback);
  }

  signupAction(e, callback) {
    const username = $('#social_email').val();
    this.createNewSocialUser(username, function(response) {
      callback(username, response);
    });
  }

  renderEmailForm () {
    const { email } = this.props.prefilledData || {};

    const metaData = [
      {
        inputFieldName: 'email',
        elementID: 'social_email',
        ref: 'socialEmail',
        optional: false,
        defaultVal: email || null
      }
    ];

    return (<FormBuilder
      ref="profileEmailForm"
      formname="email form"
      formStyle="modal"
      formInputs={metaData}
      heading=""
      description=""
      errorText={this.state.errorMsg}
      submitAction={this.signupAction}
      submitCallback={this.signupCallback}
      isButtonDisabled={false}
      buttonText={<FormattedMessage id="shared_components.social_email_form.cta_label" defaultMessage="Continue"/>}
      afterCTA={
        <div className="text-left email-opt-out">
          <TosCTAdisclaimer location="signup" buttonLabel={<FormattedMessage id="shared_components.social_email_form.cta_label" defaultMessage="Continue"/>} />
          <hr className="full-width gutter"/>
          <p className="text-small"><FormattedMessage id="shared_components.social_email_form.cta_text" defaultMessage="Peerspace will send you deals, inspiration, and marketing emails. You can opt out at any time from your account settings."/></p>
          <CheckboxField
            id="email_opt_out"
            label={<p className="text-small"><FormattedMessage id="shared_components.social_email_form.checkbox_label" defaultMessage="I don’t want to receive marketing emails from Peerspace."/></p>}
          />
        </div>
      }
    />);
  }

  render () {
    return (
      <div className="container-fluid">
        <div className="modal-header col-xs-12 text-center">
          <h4><FormattedMessage id="shared_components.social_email_form.header" defaultMessage="What's the best email for you?"/></h4>
          <br />
          <p><FormattedMessage id="shared_components.social_email_form.text" defaultMessage="We’ll send all your bookings and messages here, so make sure it’s the one you check regularly."/></p>
        </div>
        { this.renderEmailForm() }
      </div>
    );
  }
}

/*
socialData shape:
{
  email,
  first_name,
  last_name
}

prefilledData shape:
{
   email
}
*/

SocialEmail.propTypes = {
  socialData: PropTypes.object,
  prefilledData: PropTypes.object,
  socialProvider: PropTypes.string,
  socialAccessToken: PropTypes.string,
  callbackFn: PropTypes.func,
  extraSignupAttrs: PropTypes.object,
  isSignupPage: PropTypes.bool,
  entitlementId: PropTypes.string
};
